import * as React from "react";
import { Selectors } from "@grandvisionhq/auth";
import { toast } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { useSync } from "@grandvisionhq/lib-utils-w3c";
import { WithUserData, isDataLoading } from "@grandvisionhq/my-account";
import { useSelector } from "@grandvisionhq/state";
import { StepLogin } from "./StepLogin.js";
import { useCheckoutSettings } from "../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const StepLoginContainer = ({
  continueButtonLabel,
  continueTitle,
  loginTitle,
  loginSubtitle,
  continueSubtitle,
  backClickLabel,
  onContinueClick,
  userData,
  isCartLoading = true
}) => {
  const checkoutSettings = useCheckoutSettings();
  const { onClick: navigateToCart } = useLink({ route: "cart.overview" }, { replace: true }) || {};
  const isLoggedIn = useSelector(Selectors.isLoggedIn);
  const isLoading = isDataLoading(userData);
  const broadCastChannel = useSync("new-cart-created").getChannel();
  broadCastChannel.onmessage = () => {
    toast.failed("cart.errors.cartNotInActiveState");
    navigateToCart?.();
  };
  const goBackToStore = React.useCallback(() => {
    navigateToCart?.();
  }, [navigateToCart]);
  return /* @__PURE__ */ React.createElement(
    StepLogin,
    {
      isLoading: isLoading && isCartLoading,
      isLoggedIn,
      labels: {
        continueTitle,
        continueSubtitle,
        continueButtonLabel,
        loginTitle,
        loginSubtitle,
        backClickLabel
      },
      loginProps: checkoutSettings.login,
      onBackClick: goBackToStore,
      onContinueClick
    }
  );
};
const StepLoginWithUserData = WithUserData(StepLoginContainer);
const StepLoginWithMyAccountEnabled = ({ ...props }) => /* @__PURE__ */ React.createElement(StepLoginWithUserData, { ...props, isMyAccountEnabled: true });
export {
  StepLoginContainer,
  StepLoginWithMyAccountEnabled as default
};
//# sourceMappingURL=StepLoginContainer.js.map
